import { z } from "zod";
import { subCategoryResultSchema } from "@/schema/improvement-proposal/SubCategoryResult";

export const subCategoryResultCreateSchema = subCategoryResultSchema.omit({
  content: true,
  score: true,
});

export type SubCategoryResultCreate = z.infer<
  typeof subCategoryResultCreateSchema
>;
